import { createStore } from "vuex";

let lifeData = {};

try {
	// 尝试获取本地是否存在lifeData变量，第一次启动APP时是不存在的
	lifeData = uni.getStorageSync('lifeData');
} catch (e) {

}

// 需要永久存储，且下次APP启动需要取出的，在state中的变量名
let saveStateKeys = ['vuex_deviceId','vuex_platId','vuex_membid','vuex_openid','vuex_user', 'vuex_token','vuex_hasLogin','vuex_isWechat','vuex_guide','vuex_pageCur','vuex_isSerarchBack','vuex_windowWidth',
'vuex_skinColor','vuex_fontColor','vuex_backgroundColor'];

// 保存变量到本地存储中
const saveLifeData = function(key, value) {
	// 判断变量名是否在需要存储的数组中
	if (saveStateKeys.indexOf(key) != -1) {
		// 获取本地存储的lifeData对象，将变量添加到对象中
		let tmp = uni.getStorageSync('lifeData');
		// 第一次打开APP，不存在lifeData变量，故放一个{}空对象
		tmp = tmp ? tmp : {};
		tmp[key] = value;
		// 执行这一步后，所有需要存储的变量，都挂载在本地的lifeData对象中
		uni.setStorageSync('lifeData', tmp);
	}
}

const store = createStore({
	state: {
		// 登录客户端类型
		vuex_loginProvider: "",
		// 判断用户是否已登录
		vuex_hasLogin: lifeData.vuex_hasLogin ? lifeData.vuex_hasLogin : false,
		// 平台ID
		vuex_platId: lifeData.vuex_platId ? lifeData.vuex_platId : '1',
		// 会员ID
		vuex_membid: lifeData.vuex_membid ? lifeData.vuex_membid : '',
		// 微信用户openid
		vuex_openid: lifeData.vuex_openid ? lifeData.vuex_openid : '',
		// 是否是微信浏览器
		vuex_isWechat: lifeData.vuex_isWechat ? lifeData.vuex_isWechat : false,
		// 如果上面从本地获取的lifeData对象下有对应的属性，就赋值给state中对应的变量
		// 加上vuex_前缀，是防止变量名冲突，也让人一目了然
		vuex_user: lifeData.vuex_user ? lifeData.vuex_user : {},
		// 请求访问token
		vuex_token: lifeData.vuex_token ? lifeData.vuex_token : '',
		// 记录已选中页面，刷新时重新进入
		vuex_pageCur: lifeData.vuex_pageCur ? lifeData.vuex_pageCur : 'home',
		// 判断是否进入引导页
		vuex_guide: lifeData.vuex_guide ? lifeData.vuex_guide : false,
		// 判断搜索是否可返回原页面
		vuex_isSerarchBack: lifeData.vuex_isSerarchBack ? lifeData.vuex_isSerarchBack : false,
		// 屏幕宽
		vuex_windowWidth: lifeData.vuex_windowWidth ? lifeData.vuex_windowWidth : '375',
		// 如果vuex_version无需保存到本地永久存储，无需lifeData.vuex_version方式
		vuex_version: '1.0.0',
		// 自定义项目名称
		vuex_title: '奇草御康',
		// 自定义项目语言
		vuex_lang: 'zh',
		/**
		 * 自定义项目主题颜色
		 */
		// 主题颜色
		vuex_skinColor: '#3a8a79',
		// 字体颜色
		vuex_fontColor: '#ffffff',
		// 背景颜色
		vuex_backgroundColor: '#3a8a79',
		//navBar高度
		vuex_navBarHeight: 68,
		/**
		 * 自定义tabbar数据
		 */
		vuex_tabbar: [
			{
				id: 'home',
				iconPath: "shouye-weixuanzhong",
				selectedIconPath: "shouye-xuanzhong",
				text: '首页',
				customIcon: true,
				pagePath: '/pages/home/home'
			},
			{
				id: 'shop',
				iconPath: "shangcheng-weixuanzhong",
				selectedIconPath: "shangcheng-xuanzhong",
				text: '健康优库',
				customIcon: true,
				pagePath: '/pages/shop/shop',
			},
			{
				id: 'dhShop',
				iconPath: "duihuan_weixuanzhong",
				selectedIconPath: "duihuanma",
				text: '兑换专区',
				customIcon: true,
				pagePath: '/pages/shop/dhShop',
			},
			{
				id: 'cart',
				iconPath: "gouwuche-weixuanzhong",
				selectedIconPath: "gouwuche-xuanzhong",
				text: '购物车',
				customIcon: true,
				pagePath: '/pages/cart/cart'
			},
			{
				id: 'mine',
				iconPath: "gerenzhongxin-weixuanzhong",
				selectedIconPath: "gerenzhongxin-xuanzhong",
				text: '我的',
				customIcon: true,
				pagePath: '/pages/mine/mine'
			}
		]
	},
	getters:{
		currentMembId(state){
		    return state.vuex_membid
		}
	},
	mutations: {
		$uStore(state, payload) {
			// 判断是否多层级调用，state中为对象存在的情况，诸如user.info.score = 1
			let nameArr = payload.name.split('.');
			let saveKey = '';
			let len = nameArr.length;
			if(nameArr.length >= 2) {
				let obj = state[nameArr[0]];
				for(let i = 1; i < len - 1; i ++) {
					obj = obj[nameArr[i]];
				}
				obj[nameArr[len - 1]] = payload.value;
				saveKey = nameArr[0];
			} else {
				// 单层级变量，在state就是一个普通变量的情况
				state[payload.name] = payload.value;
				saveKey = payload.name;
			}
			// 保存变量到本地，见顶部函数定义
			console.log("-----------saveKey",saveKey,state[saveKey])
			saveLifeData(saveKey, state[saveKey])
		},
		$uLogin(state, provider) {
			state.hasLogin = true;
			state.loginProvider = provider;
		},
		$uLogout(state) {
			state.hasLogin = false;
			state.openid = null;
			state.loginProvider = null;
		},
		$uSetOpenid(state, openid) {
			state.openid = openid
		}
	}
})

export default store
